import { render, staticRenderFns } from "./HeaderPromo.vue?vue&type=template&id=55f77774&scoped=true"
import script from "./HeaderPromo.vue?vue&type=script&lang=js"
export * from "./HeaderPromo.vue?vue&type=script&lang=js"
import style0 from "./HeaderPromo.vue?vue&type=style&index=0&id=55f77774&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f77774",
  null
  
)

export default component.exports